import { render, staticRenderFns } from "./containerBill.vue?vue&type=template&id=cc88279c&scoped=true&"
import script from "./containerBill.vue?vue&type=script&lang=js&"
export * from "./containerBill.vue?vue&type=script&lang=js&"
import style0 from "./containerBill.vue?vue&type=style&index=0&id=cc88279c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc88279c",
  null
  
)

export default component.exports